import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        inputRoot: {
            '& > div': {
                padding: theme.spacing(0, 0.25)
            }
        }
    }
})